import { render } from "./RichtextForm.vue?vue&type=template&id=60d64c62&ts=true"
import script from "./RichtextForm.vue?vue&type=script&lang=ts"
export * from "./RichtextForm.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/inputs/form/RichtextForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "60d64c62"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('60d64c62', __exports__)) {
    api.reload('60d64c62', __exports__)
  }
  
  module.hot.accept("./RichtextForm.vue?vue&type=template&id=60d64c62&ts=true", () => {
    api.rerender('60d64c62', render)
  })

}


export default __exports__